import React from 'react';


class ModalPlaceOrderNotValidChildren extends React.Component {

    componentDidMount() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
            });
    }


    backResultPage = () => {
        this.props.setModalPlaceOrderNotValidClosedChildren();
    }


    setModalOrderConfirmationClosed = () =>  {
        this.props.setModalPlaceOrderNotValidClosedChildren();
    }
    

  render() {


    return (

            <div className="cntered-flex">
                <React.Fragment >      
                    <div className="modal_main_bg2" ></div>
                    <div className="cntered-flex">
                        <div className="modal_order_confirmation_bg_sml">

                            <div className="close_arrow pointer zindex1000" onClick={this.setModalOrderConfirmationClosed}></div>

                            <div className="modal_order_inner_bg_sml">
                              
                                    <div className="modal_order_top_sml">                            
                                        <div className="modal_order_title1"> שים לב! </div>
                                    </div>


                                    <div className="modal_order_title_hotel directionRtl">
                                    
                                    </div>


                                        <div className="cntered-flex order_cancel_text directionRtl">
                                            {this.props.modalFirstMsg}

                                        </div>  
                                    


                                <div className="modal_order_confirmation_container">
                                
                                    <div className="cntered-flex marginTop20">
                                        <div className="hp_search_main_button"
                                                onClick={() => this.backResultPage()}>
                                            <span className="hp_search_main_button_title">
                                            חזרה לדף תוצאות
                                            </span>
                                        </div>
                                    </div>
                                            
                                </div>

                            </div>

                        </div>
                    </div>                
                </React.Fragment>
            </div>
    );
  }
}



export default ModalPlaceOrderNotValidChildren;